import React from 'react';
import Markdown from 'markdown-to-jsx';
import { ChatSources } from './ChatSources';
import { extractSources, normalizeInlineHtml } from './parseChatSources';

const headingOverride = ({ children }: { children: React.ReactNode }) => (
  <strong className="chatbot-markdown-heading">{children}</strong>
);

const markdownOptions = {
  disableParsingRawHTML: true,
  forceBlock: true,
  wrapper: React.Fragment,
  overrides: {
    h1: { component: headingOverride },
    h2: { component: headingOverride },
    h3: { component: headingOverride },
    h4: { component: headingOverride },
    h5: { component: headingOverride },
    h6: { component: headingOverride },
    hr: { component: () => null },
  },
};

type ChatMarkdownProps = {
  content: string;
};

export const ChatMarkdown = ({ content }: ChatMarkdownProps) => {
  const { text, sources } = extractSources(content);
  const markdown = normalizeInlineHtml(text);

  return (
    <>
      {markdown ? (
        <div className="chatbot-markdown">
          <Markdown options={markdownOptions}>{markdown}</Markdown>
        </div>
      ) : null}
      <ChatSources sources={sources} />
    </>
  );
};
